import DocumentService from '../../services/DocumentServices';

const initialState = {
	documentElements: [],
	documentElementsForList: [],
	documentElementState: {},
	documentRedirectTo: null
};

export default {
	namespaced: true,

	//#region [ State ]
	state: {
		...initialState
	},
	//#endregion

	//#region [ Mutations ]
	mutations: {
		setDocumentElements(state, payload) {
			state.documentElements = payload;
		},

		setDocumentElementsForList(state, payload) {
			state.documentElementsForList = payload;
		},

		setDocumentElementState(state, payload) {
			state.documentElementState = payload;
		},

		reset(state) {
			Object.assign(state, initialState);
		},

		setDocumentRedirectTo(state, payload) {
			state.documentRedirectTo = payload;
		}
	},
	//#endregion

	//#region [ Actions ]
	actions: {
		async getDocumentElements({ commit }, params) {
			try {
				const res = await DocumentService.getAllDocument(params);
				if (res.Code === 200) {
					commit('setDocumentElements', res.Data);
				}
				return res;
			} catch (error) {
				console.log(error);
			}
		},

		async getDocumentElementsForList({ commit }, params) {
			try {
				const res = await DocumentService.getAllDocumentForList(params);
				if (res.Code === 200) {
					commit('setDocumentElementsForList', res.Data);
				}
				return res;
			} catch (error) {
				console.log(error);
			}
		},

		async getDocumentById({ commit }, { docId, entity, entityId }) {
			try {
				const res = await DocumentService.getDocumentById({ docId, entity, entityId });
				if (res.Code === 200) {
					commit('setDocumentElementState', res.Data);
				}
				return res;
			} catch (error) {
				console.log(error);
			}
		},

		resetDocumentStoreState({ commit }) {
			commit('reset');
		},

		setDocumentRedirect({ commit }, value) {
			commit('setDocumentRedirectTo', value);
		},

		setDocumentElementState({ commit }, value) {
			commit('setDocumentElementState', value);
		},

		// eslint-disable-next-line no-unused-vars
		async saveDocumentElement({ commit }, documentElement) {
			try {
				let res = await DocumentService.saveDocumentElement(documentElement);
				return res;
			} catch (error) {
				console.log(error);
			}
		},

		// eslint-disable-next-line no-unused-vars
		async updateDocumentElement({ commit }, documentElement) {
			try {
				let res = await DocumentService.updateDocumentElement(documentElement);
				return res;
			} catch (error) {
				console.log(error);
			}
		}
	},
	//#endregion

	//#region [ Getters ]
	getters: {}
	//#endregion
};
